import EmiScheduleList from './components/EmiScheduleList'
import InfoBanner from './components/InfoBanner'

export default function getEmiScheduleComponent(component, index) {
  const type = (component?.type || '').toLowerCase()
  switch (type) {
    case 'info':
      return <InfoBanner data={component} key={`${component?.type}-${index}`} />
    case 'emi_detail':
      return <EmiScheduleList data={component} key={`${component?.type}-${index}`} />
    default:
      return null
  }
}
